import { useCallback, useState, useEffect, useRef, useMemo } from "react";
import historyUtils from "../../../../../libs/history.utils";
import SnackbarUtils from "../../../../../libs/SnackbarUtils";
import {
  serviceGetRewardDetails,
  serviceProgramGiftAssociate,
} from "../../../../../services/GiftStore.service";
import RouteName from "../../../../../routes/Route.name";
import { serviceGetList } from "../../../../../services/index.services";
import { useParams } from "react-router-dom";

const initialForm = {
  select_all: false,
};

const useGiftStoreCreateHook = ({ isOpen, handleToggle, editData, updateGiftList }) => {
  const [form, setForm] = useState({ ...initialForm });
  const [allData, setAllData] = useState([]);
  const [data, setData] = useState([]);
  const [errorData, setErrorData] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [listData, setListData] = useState({
    GIFTS: [],
  });
  const { id } = useParams();
  const shiftRef = useRef(null);

  useEffect(() => {
   
      serviceGetList(["GIFTS"], { program_id: id }).then((res) => {
        if (!res.error) {
          const RewardList = res?.data?.GIFTS;
          const updatedData = RewardList?.map((val) => {
            return {
              ...val,
              is_checked: val.is_selected,
            };
          });
          setAllData(updatedData);
          setData(updatedData);
          setListData(updatedData);
        }
      });
   
  }, []);

  const updateTableData = useCallback(
    (data) => {
      setData(data);
    },
    [data, setData]
  );

  const handleSearchValueChange = useCallback(
    (value) => {
      const dataIds = new Set(data?.map((item) => item?.id));
      const mergedArray = [
        ...data,
        ...allData?.filter((item) => !dataIds?.has(item?.id)),
      ];
      if (value) {
        const tempData = mergedArray?.filter((val) => {
          if (val?.title?.match(new RegExp(value, "ig"))) {
            return val;
          }
        });
        setData(tempData);
      } else {
        setData(mergedArray);
      }
    },
    [data, setData, allData]
  );

  const checkFormValidation = useCallback(() => {
    const errors = { ...errorData };
    let required = [];
    required.forEach((val) => {
      if (
        !form?.[val] ||
        (Array.isArray(form?.[val]) && form?.[val].length === 0)
      ) {
        errors[val] = true;
      }
    });
    Object.keys(errors).forEach((key) => {
      if (!errors[key]) {
        delete errors[key];
      }
    });
    return errors;
  }, [form, errorData]);

  const submitToServer = useCallback(async () => {
    setIsLoading(true);
    if (!isSubmitting) {
      setIsSubmitting(true);
    }
    const RewardData = shiftRef.current.getData();
    const updatedReward = [...RewardData]?.filter((val) => val?.is_checked);
    const updatedData = {
      data: [...updatedReward],
    };
    if(!updatedReward?.length){
      SnackbarUtils.error("Please select at least one gift")
      setIsSubmitting(false);
      return
    }
    let req = serviceProgramGiftAssociate({ ...updatedData, program_id: id });

    req.then((res) => {
      if (!res.error) {
        SnackbarUtils.success(
          `${editData ? "Updated" : "Updated"} successfully`
        );
        handleToggle();
        updateGiftList();
      } else {
        SnackbarUtils.error(res.message);
      }
      setIsSubmitting(false);
    });

    setIsSubmitting(false);
  }, [form, isSubmitting, setIsSubmitting, editData, handleToggle, id, updateGiftList]);

  const handleSubmit = useCallback(async () => {
    const errors = checkFormValidation();
    const isShiftValid = shiftRef.current.isValid();
    if (!isShiftValid || Object.keys(errors).length > 0) {
      setErrorData(errors);
      return true;
    }

    await submitToServer();
  }, [checkFormValidation, setErrorData, form, errorData, id]);

  const removeError = useCallback(
    (title) => {
      const temp = JSON.parse(JSON.stringify(errorData));
      temp[title] = false;
      setErrorData(temp);
    },
    [setErrorData, errorData]
  );

  const changeTextData = useCallback(
    (text, fieldName) => {
      let shouldRemoveError = true;

      const t = { ...form };
      if (fieldName === "select_all") {
        const updateData = data?.map((val) => {
          return {
            ...val,
            is_checked: text ? true : false,
          };
        });
        setData(updateData);
        t[fieldName] = text;
      } else {
        t[fieldName] = text;
      }

      setForm(t);
      shouldRemoveError && removeError(fieldName);
    },
    [removeError, form, setForm, errorData, data, setData]
  );

  const onBlurHandler = useCallback(
    (type) => {
      if (form?.[type]) {
        changeTextData(form?.[type].trim(), type);
      }
    },
    [changeTextData]
  );

  const handleDelete = useCallback(() => {
    historyUtils.push(RouteName.USER_ROLES);
  }, [editData]);

  const handleReset = useCallback(() => {
    setForm({ ...initialForm });
    setErrorData({});
  }, [form, errorData, setErrorData]);

  return {
    form,
    errorData,
    changeTextData,
    onBlurHandler,
    handleSubmit,
    isLoading,
    handleDelete,
    isSubmitting,
    shiftRef,
    handleSearchValueChange,
    data,
    updateTableData,
    setForm,
  };
};

export default useGiftStoreCreateHook;
